import { useEffect } from "react";
import { isEmpty } from "lodash";
import { Routes, Route } from "react-router-dom";
import { useApp } from "contexts/AppContext";
import { FormContextProvider } from "contexts/FormContext";
import { getCnContentfulLocale } from "helpers/language";
import CnMigrationFormPage from "./migration-form";

export default function CnMigrationRoutes() {
  const {
    state: { rep },
    dispatch,
  } = useApp();

  useEffect(() => {
    if (isEmpty(rep) || rep.DefaultLocaleID == null) {
      return;
    }

    dispatch({
      type: "updateLocale",
      locale: getCnContentfulLocale(rep.DefaultLocaleID),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rep]);

  return (
    <FormContextProvider market="cn">
      <Routes>
        <Route path="migration-form" element={<CnMigrationFormPage />} />
      </Routes>
    </FormContextProvider>
  );
}
